import React from 'react';
import { FaHeart, FaRegHeart, FaShareAlt, FaLink } from 'react-icons/fa';
import {
  WhatsappShareButton,
  WhatsappIcon,
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
} from 'react-share';

const WishlistShareButtons = ({
  isInWishlist,
  handleWishlistClick,
  showShareOptions,
  setShowShareOptions,
  shareUrl,
  shareDescription,
  copyLinkToClipboard,
}) => {
  return (
    <>
      {/* Wishlist Button */}
      <div className="absolute top-2 left-2 flex flex-col gap-2 z-10">
        <button
          onClick={handleWishlistClick}
          className="p-2 bg-white/90 rounded-full shadow-sm hover:bg-gray-100 transition-all border border-[#f4d9c4]"
        >
          {isInWishlist ? (
            <FaHeart className="text-[#65000B] w-5 h-5" />
          ) : (
            <FaRegHeart className="text-[#65000B] w-5 h-5" />
          )}
        </button>
      </div>

      {/* Share Button */}
      <div className="absolute top-2 right-2 flex flex-col gap-2 z-10">
        <button
          onClick={() => setShowShareOptions(!showShareOptions)}
          className="p-2 bg-white/90 rounded-full shadow-sm hover:bg-gray-100 transition-all border border-[#f4d9c4]"
        >
          <FaShareAlt className="text-[#65000B] w-5 h-5" />
        </button>

        {showShareOptions && (
          <div
            className="absolute right-4 top-16 bg-white shadow-lg rounded-lg p-3 flex flex-col gap-3 w-48"
            style={{ zIndex: 9999 }}
          >
            <WhatsappShareButton url={shareUrl} title={shareDescription}>
              <div className="flex items-center gap-2 hover:bg-gray-100 p-2 rounded transition-all">
                <WhatsappIcon size={24} round />
                <span className="text-sm text-gray-600">WhatsApp</span>
              </div>
            </WhatsappShareButton>

            <FacebookShareButton url={shareUrl} quote={shareDescription} hashtag="#ShopNow">
              <div className="flex items-center gap-2 hover:bg-gray-100 p-2 rounded transition-all">
                <FacebookIcon size={24} round />
                <span className="text-sm text-gray-600">Facebook</span>
              </div>
            </FacebookShareButton>

            <TwitterShareButton url={shareUrl} title={shareDescription}>
              <div className="flex items-center gap-2 hover:bg-gray-100 p-2 rounded transition-all">
                <TwitterIcon size={24} round />
                <span className="text-sm text-gray-600">X (Twitter)</span>
              </div>
            </TwitterShareButton>

            <button
              onClick={copyLinkToClipboard}
              className="flex items-center gap-2 hover:bg-gray-100 p-2 rounded transition-all"
            >
              <FaLink className="text-[#65000B]" />
              <span className="text-sm text-gray-600">Copy Link</span>
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default WishlistShareButtons;
